import { z } from 'zod';
import { RoomExtraSchema } from '@common/features/rooms/schemas';

export const ExtraSchema = RoomExtraSchema.and(
  z.object({
    isSelected: z.boolean().optional(),
    quantity: z.number(),
    option: z
      .object({
        label: z.string(),
        value: z.number(),
      })
      .optional(),
  })
);
export const ExtrasSchema = z.array(ExtraSchema).optional();

export type OvernightPackageRoomExtras = z.infer<typeof ExtrasSchema>;
export type OvernightPackageRoomExtra = z.infer<typeof ExtraSchema>;
